// src/services/userService.js
import axiosClient from "../api/axiosClient";

const userService = {
    /**
     * Fetches all users.
     */
    getAllUsers: async () => {
        try {
            const response = await axiosClient.get('users.php');
            if (response.data && response.data.status === 'error') {
                throw new Error(response.data.message);
            }
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error("Service Error [getAllUsers]:", error);
            throw error;
        }
    },

    getMinimalUsers: async () => {
        const response = await axiosClient.get('/user-list.php');
        return response.data.data;
    },

    getUserById: async (id) => {
        const response = await axiosClient.get(`users.php?id=${id}`);
        return response.data;
    },

    /**
     * NEW: Fetch task associations for the user before purging
     */
    getUserStats: async (id) => {
        const response = await axiosClient.get(`users.php?id=${id}&stats=true`);
        return response.data;
    },

    createUser: async (userData) => {
        const response = await axiosClient.post('users.php', userData);
        return response.data;
    },

    updateUser: async (id, userData) => {
        const response = await axiosClient.put(`users.php?id=${id}`, userData);
        return response.data;
    },

    /**
     * Standard Deactivation (is_active = 0)
     */
    deleteUser: async (id) => {
        const response = await axiosClient.delete(`users.php?id=${id}`);
        return response.data;
    },

    /**
     * NEW: Hard Purge (Deletes User + All associated Tasks)
     * Triggered only after admin confirmation
     */
    purgeUser: async (id) => {
        const response = await axiosClient.delete(`users.php?id=${id}&purge=true`);
        return response.data;
    }
};

export default userService;